<template>
    <b-modal title="Manutenções" v-model="show" size="xl">
      <div class="modal-screen-list">
        <!-- :::::::::::::::::::::::::::: TABELA DE MANUTENÇÕES :::::::::::::::::::::::::::: -->
        <b-table bordered hover small head-variant="light" :items="getManutencoes" :fields="fields.manutencao">
          <template #cell(data)="data">
            <div>
              <p class="pt-0 pb-0">
                {{ moment(data.item.data).format("DD/MM/YYYY") }}
              </p>
            </div>
          </template>
  
          <template #cell(valor)="data">
            <div>
              <p>{{ formatter.format(data.item.valor) }}</p>
            </div>
          </template>
  
          <template #cell(acoes)="data">
            <div>
              <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
                <b-icon icon="pencil-square" variant="primary"> </b-icon>
              </b-button>
              <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
                <b-icon icon="trash-fill" variant="danger"> </b-icon>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
      <manutencao-edit-modal ref="manutencaoEdit" @update="update()" />
      <confirm-modal
        ref="confirmDelManutencao"
        :descricao="'Deseja realmente remover o manutenção ?'"
        @executar="executar()"
      />
  
      <template #modal-footer>
        <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
          <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
        </b-button>
        <b-button variant="secondary" @click="show = !show">Fechar</b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import { useSgcqStore } from "@/stores/SgcqStore";
  import { storeToRefs } from "pinia";
  import { VMoney } from "v-money";
  import { useVeiculoStore } from "@/stores/VeiculoStore";
  import TableFields from "@/tools/TableFields";
  import Veiculo from "@/models/Veiculo";
  import Manutencao from "@/models/Manutencao";
  import ManutencaoModal from "@/components/modals/transporte/ManutencaoModal";
  import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";
  
  export default {
    name: "ManutencaoListModal",
  
    components: {
      "manutencao-edit-modal": ManutencaoModal,
      "confirm-modal": ConfirmModal,
    },
  
    directives: { money: VMoney },
  
    data() {
      return {
        show: false,
        fields: new TableFields(),
        veiculo: new Veiculo(0, "Novo Transporte", "", "", "", "", ""),
        manutencao: new Manutencao(0, new Date(), "", "Descreva as razões para a despesa", 0, "", ""),
        manutencoes: [],
        formatter: new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }),
      };
    },
  
    methods: {
      editar(manutencao) {
        manutencao.veiculo = this.veiculo;
        this.$refs.manutencaoEdit.call(manutencao);
      },
  
      adicionar() {
        let manutencao = new Manutencao(0, new Date(), "", "Descreva as razões para a despesa", 0, "", "");
        manutencao.veiculo = this.veiculo;
        this.$refs.manutencaoEdit.call(manutencao);
      },
  
      deletar(manutencao) {
        this.manutencao.update(manutencao);
        this.$refs.confirmDelManutencao.call();
      },
  
      executar() {
        this.veiculoStore.REMOVER_MANUTENCAO(this.manutencao.id).then(() => {
          this.update();
        });
      },
  
      update() {
        this.veiculoStore.LISTAR_MANUTENCOES(this.veiculo.id).then(() => {
          this.manutencao = new Manutencao(0, new Date(), "", "Descreva as razões para a despesa", 0, "", "");
          this.manutencoes = this.getManutencoes;
        });
      },
  
      call(veiculo) {
        this.show = !this.show;
        this.veiculo = veiculo;
        this.update();
      },
    },
  
    setup() {
      const store = useSgcqStore();
      const veiculoStore = useVeiculoStore();
      const { getManutencoes } = storeToRefs(veiculoStore);
  
      return {
        store,
        veiculoStore,
        getManutencoes,
      };
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
  